module.exports = __webpack_public_path__ + "static/supporters_center_img2@2x-949669fd1cba22b609c776d4edcd5631.jpg";